import styled from '@emotion/styled';
import {Button, Dialog} from '@bosch/react-frok';

export const DialogWrapper = styled(Dialog)`
    .m-dialog__actions {
        display: grid;
        grid-template-columns: max-content auto max-content;
        justify-content: normal;
        margin-top: 0;
        width: 100%;
    }
`;

export const TextWrapper = styled.div`
    font-size: small;
    white-space: pre-line;

    & > p {
        margin-top: 0;
        font-size: 1rem;
    }
`;

export const BrowseLabel = styled.div<{ fontSize: number }>`
    margin: 1rem 0 0 0;
    min-width: 120px;
    max-width: 240px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 400;
    line-height: 1.5;
`;

export const Label = styled.label`
    display: inline-block;
    width: 100%;
`;

export const DialogEditActionsWrapper = styled.div`
    display: inline-grid;
    grid-template-columns: 1fr auto 1fr;
    column-gap: 0.5rem;
    width: 100%;
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 1rem 0 0 0;
    min-width: 120px;
    max-width: 240px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
